import { Navigate, useParams } from 'react-router-dom';

// import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS } from '@/shared';
import { useGetContrato } from '@/shared/actions/erp';
import { SaveRadCheckComponent } from '../../shared/components/SaveRadCheck';
import { LoaderComponent } from '@/shared/components/ui';

export interface UpdateRadCheckPageProps { }

const UpdateRadCheckPage: React.FC<UpdateRadCheckPageProps> = () => {
  // useCheckPermissions(PermissionsEnum.api_change_contrato);
  const returnUrlServicioClientesPage = ROUTER_PATHS.administration.radCheckEditar;

  const { id } = useParams();
  const { data, isLoading } = useGetContrato(id!);

  // if (isLoading || isRefetching) return null;
  if (isLoading) 
    return <LoaderComponent />

  if (!data?.data?.id_contrato)
    return <Navigate to={returnUrlServicioClientesPage} />;


  return <SaveRadCheckComponent title="Editar registro RAD CHECK" contrato={data.data} />;
};

export default UpdateRadCheckPage;
